// import platform from 'platform';
import { isTablet, getMsidFromPath } from 'utils/common';
// import { getCookie } from 'utils/cookies';
import {
  dimensionMapping,
  DEFAULT_GRX_STORYPUBLISHED_UPDATED_VALUE,
} from '../constants';

function formatDate(date) {
  const dateObj = new Date(date);
  return dateObj.getTime() ? dateObj.getTime().toString() : '';
}

function getNavSections(data) {
  const navsecs = data.navsubsecs ? Object.values(data.navsubsecs) : '';
  let section = '';
  let subsection = '';
  let denmarkFolderId = '';
  if (navsecs) {
    navsecs.forEach((navsec, index) => {
      if (navsec[`seolocation${index}`]) {
        if (!section) {
          section = navsec[`seolocation${index}`];
        } else {
          subsection = navsec[`seolocation${index}`];
        }
        denmarkFolderId = navsec[`subsecmsid${index}`];
      }
    });
    if (subsection) {
      subsection = subsection.replace(`${section}/`, '');
    }
  } else if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.pathname
  ) {
    section = window.location.pathname.split('/')[1];
    subsection = window.location.pathname
      .split('/')
      .slice('2', -3)
      .join('/');
  }
  return { section, subsection, denmarkFolderId };
}

function getAuthorsName(authorsData) {
  if (!authorsData) {
    return '';
  }
  const authorsNames = [];
  authorsData.forEach(authorData => {
    const name = authorData?.name;
    if (!authorsNames.includes(name)) {
      authorsNames.push(name);
    }
  });
  return authorsNames.join(' and ');
}

export function setGrxParamsRelatedToData(data = {}, params = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  window.grxParams = window.grxParams ? window.grxParams : {};

  const msid = data
    ? data.id || data.msid || data?.timelineData?.msid
    : getMsidFromPath(window.location.href) || 'NA';
  const authorName = getAuthorsName(data.authors);
  const title = data.hl || data?.timelineData?.title1 || 'NA';
  const sectionNames = getNavSections(data);
  const metaInfo = data.metaInfo ? data.metaInfo : {};
  const seoInfo = data.seo || data?.seoData?.data || {};
  const datePublished = Date.parse(seoInfo.datePublished)
    ? seoInfo.datePublished
    : data.datePublishedNew;
  const dateModified = Date.parse(seoInfo.dateModified)
    ? seoInfo.dateModified
    : datePublished;
  const agency = data.ag || data.agency || 'NA';
  const contentType = data.contenttype ? data.contenttype : params.contentType;

  // Setting GRX Params in window which will be set to grx later
  window.grxParams[dimensionMapping.dimension71] = params.onPlatformSource
    ? params.onPlatformSource
    : 'Click';
  window.grxParams[dimensionMapping.dimension58] = !!(
    data &&
    data.cs &&
    data.cs.toLowerCase() === 'prime'
  );
  window.grxParams[dimensionMapping.dimension31] = msid;
  window.grxParams[dimensionMapping.dimension4] = authorName || 'NA';
  window.grxParams[dimensionMapping.dimension35] = title;
  window.grxParams[dimensionMapping.dimension75] = title;
  window.grxParams[dimensionMapping.dimension76] = sectionNames.section || 'NA';
  window.grxParams[dimensionMapping.dimension77] =
    sectionNames.subsection || 'NA';
  window.grxParams[dimensionMapping.dimension74] = sectionNames.denmarkFolderId
    ? sectionNames.denmarkFolderId
    : 'NA';
  window.grxParams[dimensionMapping.dimension60] = metaInfo.NatureOfContent
    ? metaInfo.NatureOfContent
    : 'NA';
  window.grxParams[dimensionMapping.dimension61] = metaInfo.TopicTree
    ? metaInfo.TopicTree
    : 'NA';
  window.grxParams[dimensionMapping.dimension66] = Date.parse(datePublished)
    ? formatDate(datePublished)
    : DEFAULT_GRX_STORYPUBLISHED_UPDATED_VALUE;
  window.grxParams[dimensionMapping.dimension67] = Date.parse(dateModified)
    ? formatDate(dateModified)
    : DEFAULT_GRX_STORYPUBLISHED_UPDATED_VALUE;
  window.grxParams[dimensionMapping.dimension68] = agency;
  window.grxParams[dimensionMapping.dimension70] = contentType;
  window.grxParams[dimensionMapping.dimension78] = contentType;
  window.grxParams[dimensionMapping.dimension9] = contentType || 'NA';
  if (contentType === 'liveblog') {
    window.grxParams[dimensionMapping.dimension69] = metaInfo.LiveBlogName
      ? metaInfo.LiveBlogName
      : 'NA';
  }
}

// eslint-disable-next-line import/prefer-default-export
export function setGrxParamsRelatedToUser() {
  if (typeof window === 'undefined') {
    return;
  }

  window.grxParams = window.grxParams ? window.grxParams : {};

  // const city = getCookie('geolocation');
  // const countryCode = getCookie('geo_country');
  // const state = getCookie('grxgeostate');
  let userPlatform = 'Desktop';
  if (isTablet()) {
    userPlatform = 'Tablet';
  } else if (window.App.state.isMobile) {
    userPlatform = 'Mobile';
  }
  // Setting GRX Params in window which will be set to grx later
  // window.grxParams[dimensionMapping.dimension82] = city || 'NA';
  // window.grxParams[dimensionMapping.dimension55] = state || 'NA';
  // window.grxParams[dimensionMapping.dimension56] = countryCode || 'NA';
  window.grxParams[dimensionMapping.dimension62] =
    userPlatform === 'Desktop' ? 'web' : 'mweb';
  window.grxParams[dimensionMapping.dimension65] = userPlatform;
  window.grxParams[dimensionMapping.dimension72] =
    typeof document !== 'undefined' &&
    document.referrer &&
    document.referrer.includes('google')
      ? 'organic'
      : 'direct';
  // window.grxParams[dimensionMapping.dimension63] = platform.manufacturer
  //   ? platform.manufacturer
  //   : 'NA';
  // window.grxParams[dimensionMapping.dimension64] = platform.product
  //   ? platform.product
  //   : 'NA';
  // window.grxParams[dimensionMapping.dimension79] =
  //   platform.os && platform.os.version ? platform.os.version : 'NA';
  // window.grxParams[dimensionMapping.dimension80] =
  //   platform.os && platform.os.family ? platform.os.family : 'NA';
  window.grxParams[dimensionMapping.dimension73] = 'screen_view';
}

// eslint-disable-next-line import/prefer-default-export
export function setGrxParams(data, params = {}) {
  try {
    if (typeof window !== 'undefined') {
      setGrxParamsRelatedToUser();
      setGrxParamsRelatedToData(data, params);
    }
  } catch (error) {
    console.log('Error in setting grx params', error);
  }
}
